<template>
  <div></div>
</template>
<script>
export default {
  name: "face1",
  props: {
    trainItemExamId: { type: Number },
    businessType: { type: Number },
    examId: { type: Number },
    businessId: { type: Number },
    confirm: { type: Boolean },
    faceType: {type: String},
    courseId:{
        type: Number,
        default:null
    },
    taskId:{type:Number},
    courseBeforeAndAfterType:{type:Number},
    nodeId:{type:Number}, // 任务大纲节点id
    resourceId:{type:Number} // 当前播放资源id
  },
    created(){
        console.log(this.courseId,'this.courseId')
        console.log(this.nodeId,'nodeid');
        console.log(this.courseBeforeAndAfterType,this.taskId,'=========');

    },
  mounted() {
      console.log(this.courseId,'this.courseId')
    var facecount = localStorage.getItem("facecount");
    if(this.confirm){
      this.getAlert()
    }else{
      this.getConfirm()
    }
  },
  methods: {
      /* eslint-disable */
    changeUrlArg(url, arg, val){
        var pattern = arg+'=([^&]*)';
        var replaceText = arg+'='+val;
        return url.match(pattern) ? url.replace(eval('/('+ arg+'=)([^&]*)/gi'), replaceText) : (url.match('[\?]') ? url+'&'+replaceText : url+'?'+replaceText);
    },
    getAlert() {
      this.$dialog.alert({
          title: "身份验证",
          message: "请进行人脸识别验证",
      }).then(() => {
        console.log(this.courseId,'this.courseId')
          var faceidentifylocalUrl = this.courseId ? this.changeUrlArg(window.location.href,'courseId',this.courseId) :window.location.href ;
          if(this.nodeId){
              faceidentifylocalUrl = `${faceidentifylocalUrl}&nodeId=${this.nodeId}&resourceId=${this.resourceId}`
          }
          console.log(faceidentifylocalUrl,'faceidentifylocalUrl')
          localStorage.setItem("faceidentifylocalUrl", faceidentifylocalUrl);
          var trainItemExamId = this.trainItemExamId;
          var businessType = this.businessType;
          var examId = this.examId;
          var businessId = this.businessId;
          var faceType = this.faceType;
          let taskId = this.taskId;
          let courseBeforeAndAfterType = this.courseBeforeAndAfterType;//定制山东应急需要
          // window.location.replace(
          //   `${window.location.protocol}//${window.location.host}/faceidentify?trainItemExamId=${trainItemExamId}&businessType=${businessType}&examId=${examId}&isExamFaceRecognize=${isExamFaceRecognize}&businessId=${businessId}`
          // );
          this.$router.push({
               path:'/faceidentify',
               query:{
                 trainItemExamId,
                 businessType,
                 examId,
                 businessId,
                 faceType,
                 taskId,
                 courseBeforeAndAfterType
               }
             })
        })
        .catch(() => {
          this.$emit("close", false);
        });
    },
    getConfirm() {
      // if(facecount <= 5){
        
      this.$dialog
        .confirm({
          title: "身份验证",
          message: "请进行人脸识别验证",
          className:'faceconfirm',
        })
        .then(() => {
          console.log('getConfirm')
            var faceidentifylocalUrl = this.courseId ? this.changeUrlArg(window.location.href,'courseId',this.courseId) :window.location.href ;
        //   var faceidentifylocalUrl = window.location.href;
        if(this.nodeId){
              faceidentifylocalUrl = `${faceidentifylocalUrl}&nodeId=${this.nodeId}&resourceId=${this.resourceId}`
          }
          localStorage.setItem("faceidentifylocalUrl", faceidentifylocalUrl);
          var trainItemExamId = this.trainItemExamId;
          var businessType = this.businessType;
          var examId = this.examId;
          var businessId = this.businessId;
          var faceType = this.faceType;
          let taskId = this.taskId;
          let courseBeforeAndAfterType = this.courseBeforeAndAfterType;//定制山东应急需要
          // window.location.replace(
          //   `${window.location.protocol}//${window.location.host}/faceidentify?trainItemExamId=${trainItemExamId}&businessType=${businessType}&examId=${examId}&isExamFaceRecognize=${isExamFaceRecognize}&businessId=${businessId}`
          // );
          this.$router.push({
               path:'/faceidentify',
               query:{
                 trainItemExamId,
                 businessType,
                 examId,
                 businessId,
                 faceType,
                 taskId,
                 courseBeforeAndAfterType
               }
             })
          // this.$router.push("/faceidentify")
        })
        .catch(() => {
          this.$emit("close", false);
        });
    },
  },
};
</script>
<style lang="less">
  .faceconfirm {
    .van-dialog__footer{
        width:100% !important;
    }
    .van-button--default{
        color: #323233 !important;
        background-color: #fff !important;
        border: 1px solid #ebedf0 !important;
    }
}
</style>
<style scoped lang="less">
.top {
  width: 750px;
  height: 974px;
  background: linear-gradient(143deg, #368dff 0%, #4a66f5 100%);
}

</style>